// Convert SHOUTING owner strings ("HELICOPTERS INC") to display case
// ("Helicopters Inc") while preserving recognized all-caps acronyms (NYPD,
// FAA, NYC, USCG, etc.) and small connectors (of, and, the).
//
// Pure function. Returns null/undefined unchanged so callers can use it in
// an || fallback chain.

// Suffixes like INC / LLC / LP / CO are deliberately NOT acronyms — keeping
// them uppercase preserves the registry-shouty feel we're trying to soften.
const ACRONYMS = new Set([
  'NYPD', 'FDNY', 'NYC', 'USCG', 'FAA', 'FBI', 'DEA', 'ATF', 'DEP',
  'CBP', 'TSA', 'DOI', 'DOJ', 'EMS', 'SAR',
  'TV', 'ABC', 'NBC', 'CBS', 'FOX', 'CNN', 'WABC', 'WNBC', 'WCBS',
  'WPIX', 'WNYW', 'PD', 'SP', 'HQ', 'USA', 'US', 'UK', 'JFK', 'LGA',
  'EWR', 'NJ', 'NY', 'CT', 'PA',
]);

const SMALL_WORDS = new Set([
  'of', 'and', 'the', 'a', 'an', 'or', 'for', 'in', 'on', 'at',
  'to', 'by', 'de', 'la', 'le', 'el',
]);

/**
 * @param {string | null | undefined} input
 * @returns {string | null | undefined}
 */
export function titleCase(input) {
  if (input == null) return input;
  const trimmed = String(input).trim();
  if (trimmed.length === 0) return trimmed;

  return trimmed
    .toLowerCase()
    .split(/(\s+|[/&-])/) // keep separators
    .map((token, idx, arr) => {
      if (/^\s+$/.test(token) || token === '/' || token === '&' || token === '-') {
        return token;
      }
      const upper = token.toUpperCase();
      if (ACRONYMS.has(upper)) return upper;
      if (idx > 0 && SMALL_WORDS.has(token)) return token;
      // First letter cap, preserve digits and apostrophes mid-word
      return token.charAt(0).toUpperCase() + token.slice(1);
    })
    .join('');
}

export default titleCase;
